import React from "react";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { createRoot } from 'react-dom/client';



import "bootstrap/dist/css/bootstrap.min.css";
import "react-owl-carousel2/src/owl.carousel.css";
import "./assets/scss/App.scss";
import "./index.css";


const container = document.getElementById('root');
const root = createRoot(container);

const error = console.error;
console.error = (...args) => {
  if (/ResizeObserver loop/.test(args[0])) return;
  error(...args);
};



root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();
